<template>
    <div>
        <vs-table :data="employees" stripe pagination >

            <template slot="thead">
                <vs-th width="60"></vs-th>
                <vs-th width="60">Foto</vs-th>
                <vs-th>Nome</vs-th>
                <vs-th>Email</vs-th>
                <vs-th width="140">Função</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].email">
                        <vx-tooltip :text="data[indextr].main ? 'Impossível remover o criador da empresa' : 'Remover colaborador'">
                            <a-button :disabled="data[indextr].main" color="danger" type="dashed"  icon="delete" @click="remove(data[indextr])" shape="circle"/>
                        </vx-tooltip>
                    </vs-td>

                    <vs-td :data="data[indextr].photoURL">
                        <vs-avatar size="small" :src="data[indextr].photoURL"/>
                    </vs-td>

                    <vs-td :data="data[indextr].name">
                        {{ data[indextr].name }}
                    </vs-td>

                    <vs-td :data="data[indextr].email">
                        {{ data[indextr].email }}
                    </vs-td>

                    <vs-td id="datableEmployees" :data="data[indextr].role" v-if="renderedForm">
                        <vx-tooltip :text="!data[indextr].main ? 'Alterar função do colaborador' : 'Impossível alterar a função do criador da empresa'">
                        <a v-if="!data[indextr].main" @click="showEditRoleFrm(data[indextr].uid, data[indextr].role)"> {{ availableRoles[data[indextr].role] }} </a>
                        <span v-else> {{ availableRoles[data[indextr].role] }} </span>
                        </vx-tooltip>
                    </vs-td>
                </vs-tr>
            </template>

        </vs-table>

        <a-modal
            v-model="editRoleFrm.showFrm"
            title="Alterar função"
            cancel-text="Cancelar"
            ok-text="Alterar função"
            :confirm-loading="editRoleFrm.loading"
            :width="400"
            @ok="saveNewRole()">
            <select-employee-role :label="true" :label-text="'Escolha a nova função:'" @change="(value) => editRoleFrm.newRole = value" />
        </a-modal>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import SelectEmployeeRole from '@/components/shared/SelectEmployeeRole'

    export default {
        components :{
            SelectEmployeeRole
        },

        data () {
            return {
                ref : firebase.firestore(),
                employees : [],
                editRoleFrm : {
                    showFrm : false,
                    newRole : 2,
                    userId : '',
                    loading : false
                },
                availableRoles : {
                    0 : 'Administrador',
                    1 : 'Gestor',
                    2 : 'Garçom'
                },
                renderedForm : false
            }
        },

        mounted () {
            // this.$message.config({ top: '80px'})
            this.getEmployees()
        },

        methods : {
            showEditRoleFrm (userId, role) {
                this.$set(this.editRoleFrm, 'loading', false)
                this.$set(this.editRoleFrm, 'userId', userId)
                this.$set(this.editRoleFrm, 'showFrm', true)
            },

            async saveNewRole (newRole) {
                let companyId = this.$store.getters.getCompanyID
                try {
                    this.$set(this.editRoleFrm, 'loading', true)
                    if(this.editRoleFrm.userId == null)  throw new Error('Nenhuma empresa foi selecionada!')
                    if(this.editRoleFrm.newRole == null) throw new Error('Nenhuma função foi selecionada!')

                    await this.ref.collection('company').doc(companyId).collection('companyUsers').doc(this.editRoleFrm.userId).update({ role: this.editRoleFrm.newRole })
                    this.$set(this.editRoleFrm, 'showFrm', false)
                } catch (err) {
                    this.$message.error(`ERRO: ${err.message}`, 7)
                } finally {
                    this.$set(this.editRoleFrm, 'loading', false)
                }
            },

            getEmployees () {
                let companyId = this.$store.getters.getCompanyID
                this.ref.collection('company').doc(companyId).collection('companyUsers')
                    .where('blocked', '==', false)
                    .onSnapshot(snapshot => {
                        this.renderedForm = true
                        snapshot.docChanges().forEach(change => {
                            if(change.type === "added") {
                                this.addEmployee(change.doc.data())
                            }
                            if(change.type === "modified") {
                                this.updateEmployee(change.doc.data())
                            }
                            if(change.type === 'removed') {
                                this.removeEmployee(change.doc.data())
                            }
                        })
                    })
            },

            addEmployee (doc) {
                this.employees.push(doc)
                this.$emit('change', this.employees)
            },

            updateEmployee (doc) {
                this.employees.forEach((k, i) => {
                    if(k.uid == doc.uid) {
                        this.$set(this.employees, i, {...this.employees[i], ...{ role : doc.role }})
                        this.$emit('change', this.employees)
                    }
                })
            },

            removeEmployee (doc) {
                this.employees.forEach((k, i) => {
                    if(k.uid == doc.uid) {
                        this.$delete(this.employees, i)
                        this.$emit('change', this.employees)
                    }
                })
            },

            remove (doc) {
                try {
                    let that = this
                    let companyId = this.$store.getters.getCompanyID

                    this.$vs.dialog({
                        type: 'confirm',
                        title: 'Confirmação necessária!',
                        text : 'Tem certeza que deseja remover este colaborador?',
                        acceptText: 'Quero remover',
                        cancelText: 'Cancelar!',
                        accept () {
                            if(!doc.main) that.ref.collection('company').doc(companyId).collection('companyUsers').doc(doc.uid).update({ blocked : true });
                                else this.$message.error('Impossível remover o criador da empresa!', 7)
                        },
                    })
                } catch (err) {
                    this.$message.error(`ERRO: ${err.message}`, 7)
                } finally {

                }
            }
        }
    }
</script>

<style scoped>
    .con-vs-popup .vs-popup {
        width: 350px !important;
        height: auto !important;
    }
</style>